import React, {FC, useCallback} from 'react';
import styled from 'styled-components';
import colors from '../../../config/colors';
import Filters from '../Filters';

// Modal Components
import {Modal} from '../../../components/Modal';
import ModalContainer from '../../../components/Modal/ModalContainer';
import ModalClose from '../../../components/Modal/ModalClose';
import ModalBody from '../../../components/Modal/ModalBody';

interface IFiltersModal {
    closeModal: (value: any)=>void ;
    isOpen: any;
    searchResults?: (results: any) => void;
}

const FiltersModal:FC<IFiltersModal> = ({closeModal, isOpen, searchResults}) => {

    const closeOnClick = useCallback(() => {
        closeModal('');
    }, [closeModal]);

    return (
      <ModalFilters className={isOpen ? 'modalOpen' : ''}>
        <ModalContainerFilters>
          <ModalCloseFilters onClick={closeOnClick}><svg className="isvg"><use xlinkHref={`#close`} /></svg></ModalCloseFilters>
          <ModalBodyFilters>
            <Filters closeModal={()=> closeModal('')}  searchResults={searchResults} />
          </ModalBodyFilters>
        </ModalContainerFilters>
      </ModalFilters>
    )
}

const ModalFilters = styled(Modal)`
  padding: 0 !important;
  background: ${colors.WHITE_COLOR};
  transform: unset;

  &.modalOpen > div {
    transform: unset;
  }

  .filters__search {
    position: fixed;
    bottom: 35px;
    right: 50%;
    transform: translateX(50%);
    z-index: 1003;
  }

  .select-wrapper {

    &.hasValue {

      img {
        display: none;
      }

      .select-wrapper__clear {

        @media (max-width: 767px) {
          display: block;
        }
      }
    }
  }

  .rbt {

    .rbt-aux {
      background: none;
    }

    .rbt-aux button {
      margin-right: 6px;
      opacity: 0.7;

      @media (max-width: 767px) {
        margin-right: 0;
      }
    }
  }
`;

const ModalContainerFilters = styled(ModalContainer)`
  box-shadow: none;
  border-radius: 0;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
`;

const ModalCloseFilters = styled(ModalClose)`
  z-index: 1003;
  width: 40px;
  height: 40px;
  display: flex;
  box-shadow: 0 0 20px rgba(93,93,93,0.16);
  background: ${colors.WHITE_COLOR};
  border-radius: 40px;

  img, .isvg {
    margin: auto;
  }
`;

const ModalBodyFilters = styled(ModalBody)`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  border-bottom: 1px solid rgba(93,93,93,0.1);
  overflow-y: auto;

  @media (max-width: 767px) {
    padding: 88px 15px 108px;
  }

  label {
    font-size: 12px;
    font-weight: 400;
  }
`;

export default FiltersModal;
